import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';

import { styles } from './layout-with-sidebar.styles';

const LayoutWithSidebar = ({
  header: HeaderComponent,
  content: ContentComponent,
  side: SideComponent,
  rail: RailComponent,
  classes,
  ...props
}) => {
  return (
    <>
      {HeaderComponent && <HeaderComponent {...props} />}
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-start"
        className={classNames(classes.container, { [classes.withRail]: RailComponent })}
      >
        {RailComponent && (
          <Grid className={classes.rail}>
            <RailComponent {...props} />
          </Grid>
        )}
        <Grid className={classes.side}>{SideComponent && <SideComponent {...props} />}</Grid>
        {ContentComponent && (
          <Grid className={classes.content}>
            <ContentComponent {...props} />
          </Grid>
        )}
      </Grid>
    </>
  );
};

LayoutWithSidebar.propTypes = {
  header: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  side: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  // Condensed layout only: a narrow navigation column left of the content, which moves the side column right.
  rail: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  classes: PropTypes.object.isRequired
};
LayoutWithSidebar.defaultProps = {
  header: null,
  content: null,
  side: null,
  rail: null
};

export default withStyles(styles)(LayoutWithSidebar);
